/**
 * Fill in the deep-mode URL templates from views._build_ai_chat_config: they carry session
 * id 0, run id 0 and the artifact name 'artifact_0', reversed server-side so the paths
 * themselves never have to be hard-coded here.
 */
export function sessionUrl(template, sessionId) {
    return template.replace('/sessions/0/', "/sessions/".concat(sessionId, "/"));
}
export function runUrl(template, sessionId, runId) {
    return sessionUrl(template, sessionId).replace('/runs/0/', "/runs/".concat(runId, "/"));
}
export function artifactUrl(template, sessionId, artifactId) {
    return sessionUrl(template, sessionId).replace('/artifact_0/', "/".concat(encodeURIComponent(artifactId), "/"));
}
